<div mat-dialog-content>
  <goa-signin-callout
    mt="20"
    heading="Important update for Justice Digital user"
    type="information"
  >
    <ul>
      <li>
        Justice Digital has made changes that allow you to access multiple
        services with one account.
      </li>
      <li>These changes require all users to update their password.</li>
    </ul>

    <p><strong>on the next screen...</strong></p>

    <ul>
      <li>
        If you have not already done so, click "Forgot password" and create a
        new password for all your Justice Digital services
      </li>
      <li>
        If you have already updated the password, sign in with the same email
        and password you use other Justice Digital services
      </li>
    </ul>

    <div mat-dialog-actions fxLayout="row" fxLayoutAlign="end">
      <button mat-stroked-button color="primary" mat-dialog-close>Back</button>
      <button mat-raised-button color="primary" [mat-dialog-close]="true">
        Continue
      </button>
    </div>
  </goa-signin-callout>
</div>
